// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.



document.addEventListener('cart:item-added', function (evt) {
  console.log('Item added to the cart');
  console.log(evt.detail.product);
  if (evt.detail.product.id == 41765535056065 ) {
    console.log("MATCH");
   document.getElementById('deskupsell').style.display = "block"; 
   document.getElementById('mobupsell').style.display = "block";
  } else {
    document.getElementById('deskupsell').style.display = "none"; 
   document.getElementById('mobupsell').style.display = "none";
  }
  
}); // This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
// The cart is checked for items to upsell sugested-products.liquid for, if the cart contains either product ID's the upsell elements are shown.

document.addEventListener('cart:updated', function (evt) {
  console.log('Cart updated');
  console.log(evt.detail.cart);
}); // This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.

document.addEventListener('cart:error', function (evt) {
  console.log('Cart error');
  console.log(evt.detail.errorMessage);
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener('quick-cart:open', function (evt) {
  console.log('Quick cart opened');
  console.log(evt.detail.cart);
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.

document.addEventListener('quick-cart:close', function () {
  console.log('Quick cart closed');
}); // This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.

document.addEventListener('product:variant-change', function (evt) {
  console.log('Product variant changed');
  // console.log(evt.detail.variant);
}); // This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.

document.addEventListener('product:quantity-update', function (evt) {
  console.log('Product quantity updated');
  console.log(evt.detail.quantity, evt.detail.variant);
});

document.addEventListener('DOMContentLoaded', function () {
  console.log('DOMContentLoaded');


  var rellax = new Rellax('.rellax');

      $( ".questions__accordion" ).find(".filter__ingredients").hide();

      // bind filter button click
      $('#filters').on( 'click', 'button', function() {
        var filterValue = $( this ).attr('data-filter');
        // use filterFn if matches value
        var filtervaluewhatever = document.body.querySelectorAll('.'+ filterValue);
        console.log(filtervaluewhatever);
        
        $( ".questions__accordion-group" ).hide();
        $( ".questions__accordion" ).find( filtervaluewhatever ).show();

      });


      // change is-checked class on buttons
      $('.button-group').each( function( i, buttonGroup ) {
        var $buttonGroup = $( buttonGroup );
        $buttonGroup.on( 'click', 'button', function() {
          $buttonGroup.find('.is-checked').removeClass('is-checked');
          $( this ).addClass('is-checked');
        });
      });




      var planSelector = document.querySelector("input[value='67a3ea8e0a901802261e3873334d6af965449464']");

      if (planSelector) {
        planSelector.click();
      }

      var pin = $('.shoppable-item__hotspot')[0];
      
      //is viewport is wider than 767px
      if (window.innerWidth > 767) {
        if (pin) {
          pin.click();
        }
      }


    
    var formulaVideo = document.getElementById("formula-video");

    var announcement = document.getElementById("shopify-section-announcement-bar");
    var sectionheader = document.getElementById("shopify-section-header");

    var announcementHeight = $(announcement).innerHeight();
    var sectionheaderHeight = $(sectionheader).innerHeight();

    var offsetHeight = announcementHeight + sectionheaderHeight;

    var screenHeight = window.innerHeight - offsetHeight;


    if(formulaVideo){
      if(window.innerWidth > 767) {
        formulaVideo.setAttribute('height', screenHeight);
      }
    }
  
    function replaceformulaVide() {
      
      var video = document.getElementById('formula-video-mobile');
      var source = document.createElement('source');

      if(video) {
        if(window.innerWidth > 767) {

            source.setAttribute('src', 'https://cdn.shopify.com/videos/c/o/v/ef0bba1e6f914ead8200a54e12dba308.mp4');
            source.setAttribute('type', 'video/mp4');

            video.appendChild(source);
            video.play();
            console.log({
              src: source.getAttribute('src'),
              type: source.getAttribute('type'),
            });

        } else {
           
            source.setAttribute('src', 'https://cdn.shopify.com/videos/c/o/v/864de15113584e25b1fcd4de5813bb42.mp4');
            source.setAttribute('type', 'video/mp4');

            video.appendChild(source);
            video.play();
            console.log({
              src: source.getAttribute('src'),
              type: source.getAttribute('type'),
            });
        }
      }
      
  }
  
  replaceformulaVide();

      function serviceHover() {

        var servicesHover = document.querySelectorAll('.questions__accordion-group');
      
        var servicesImage = document.querySelector(".image__benefits");

        if (servicesImage) {
        //preload images function
        function preloadImage(url) {
            var img=new Image();
            img.src=url;
        }
      
        servicesHover.forEach(function(element, index) {
          index++;
      
          var url = element.dataset.image;
      
          window.addEventListener("load", function(){
            preloadImage(url);
          });
      
          element.addEventListener('mouseover', event => {
            
            if (element.dataset.image) {
              // console.log('has url'+ servicesImage.getAttribute('src'));        
              servicesImage.setAttribute('src', url);
            } else {
              console.log('has no url added in admin');        
            }
      
          });
      
         
        });
      }
      
      }

      serviceHover();


      //on click
      $('.announcement-bar__link').click(function(e) {
        e.preventDefault();
        $('.popup').addClass('visible');
      });


      var columns = document.querySelectorAll('.questions__accordion-group');
      function clearColumns() {
          $(columns).removeClass('is-active');
          $(columns).find('.questions__accordion-label').attr('aria-expanded', 'false');
          $(columns).find('.questions__accordion-answer').attr('aria-hidden', 'false');
          $(columns).find('.questions__accordion-answer').css('display', 'none');
      }

      function showColumn(column) {
        clearColumns();
        $(column).addClass('is-active');
        $(column).find('.questions__accordion-label').attr('aria-expanded', 'true');
        $(column).find('.questions__accordion-answer').attr('aria-hidden', 'true');
        $(column).find('.questions__accordion-answer').css('display', 'block');
      }

      columns.forEach(element => {
        $(element).on( 'click', function() {
          $(element).hasClass('is-active') ? clearColumns() : showColumn(element);
        });
      });
    

      //This is the code for the variant trick with paywhilr
      var hiddenDropdown = document.getElementById("Option1");

      function fireEvent() {
        var fireevent = new Event('change');
        hiddenDropdown.dispatchEvent(fireevent);
      }

      $('.subscribe__option label').click(function(e) {
        document.getElementById("Option1").selectedIndex = 0;
        fireEvent();
        checkSelection();
      });

      $('.onetime_option label').click(function(e) {
        document.getElementById("Option1").selectedIndex = 1;
        fireEvent();
        checkSelection();
      });

      function checkSelection() {
        $('.subscribe__option').removeClass('paywhirl-group-selected');
        $('.onetime_option').removeClass('paywhirl-group-selected');

        var optionDropdown = document.getElementById("Option1");

        if(optionDropdown) {
          if (document.getElementById("Option1").selectedIndex == 1) {
            // console.log('selected index: ' + document.getElementById("Option1").selectedIndex);

            $('.onetime_option').addClass('paywhirl-group-selected');
          } else {
            $('.subscribe__option').addClass('paywhirl-group-selected');
          }
        }

        // console.log('selected index: ' + document.getElementById("Option1").selectedIndex);
      }

      checkSelection();


      //on click click another button
      // $('.quick-purchase-bar__purchase-button-custom').click(function(e) {
      //   // e.preventDefault();
      //   $('.product-form__cart-submit').click();
      // });


    //   document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    //     anchor.addEventListener('click', function (e) {
    //       console.log("log!");
    //         e.preventDefault();
    //       	 const pageTransitionElement = document.querySelector('.page-transition');

          
    //         if(pageTransitionElement) {
    //           Object.assign(pageTransitionElement.style, {
    //             opacity: 0,
    //             display: 'none'
    //           });
    //         }
          
    //     });
    // });



});



